import { render } from "./CustomerRankingLink.vue?vue&type=template&id=3845b6c4&ts=true"
import script from "./CustomerRankingLink.vue?vue&type=script&lang=ts"
export * from "./CustomerRankingLink.vue?vue&type=script&lang=ts"

import "./CustomerRankingLink.vue?vue&type=style&index=0&id=3845b6c4&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__